import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import _ from 'underscore';

import { Page } from '../components';
import {
  FormContent,
  PrimaryContent,
} from '../components/Content/CategoriesScreen';
import { withSelectedCategoriesData } from '../hocs/withData';
import { Row } from '../components/Structure';

ReactGA.pageview(window.location.pathname + window.location.search);

const CatElement = ({ Code = '', Name = '' }) => (
  <p>
    <span>{`${Code}:`}</span>
    <span className="cat-description">{Name}</span>
  </p>
);

const CategoriesScreen = ({ SelectedCategoriesData = {} }) => {
  const { selectedCategories = [] } = SelectedCategoriesData;
  const [selected, setSelected] = useState(false);
  useEffect(() => {
    const isEmpty = !_.isEmpty(selectedCategories);
    if (isEmpty === true) {
      setSelected(true);
    }
  }, [selected]);

  const CategoriesList = () => selectedCategories.map((Categories) => {
    const Code = Categories.code;
    const Name = Categories.name;
    return <CatElement Code={Code} Name={Name} key={`key-${Code}`} />;
  });

  return (
    <Page id="main" className="categories-screen">
      <PrimaryContent />
      <FormContent selected={selected} />
      <Row className="selected-row">
        <CategoriesList />
      </Row>
    </Page>
  );
};

export default withSelectedCategoriesData(CategoriesScreen);
